const BASE = (process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend').replace(/\/$/, '')

function headers() {
  const h = { 'Content-Type': 'application/json', Accept: 'application/json' }
  const token = localStorage.getItem('accessToken')
  if (token) h.Authorization = `Bearer ${token}`
  return h
}

async function request(method, url, body) {
  const opts = { method, headers: headers() }
  if (body) opts.body = JSON.stringify(body)
  const resp = await fetch(`${BASE}${url}`, opts)
  const data = await resp.json()
  return { data, status: resp.status }
}

export class FolderService {
  static getALLFolders() {
    return request('GET', '/folders')
  }

  static getFolder(folderId) {
    return request('GET', `/folder/${folderId}`)
  }

  static getFolderUserId(folderId) {
    return request('GET', `/folderUser/${folderId}`)
  }

  static createFolder(folder) {
    return request('POST', '/folder/', folder)
  }

  static updateFolder(folder, folderId) {
    return request('PUT', `/folder/${folderId}`, folder)
  }

  static deleteFolder(folderId) {
    return request('DELETE', `/folder/${folderId}`)
  }
}
